import moment from "moment";

const devolutions_fields = {
  "#RQ": "id",
  "Linea naviera": {
    field: "service.shipping_line",
    callback: (shipping_line) => {
      return shipping_line ? shipping_line.name : "";
    },
  },
  "BL/BK": {
    field: "service.doc_number",
    callback: (doc_number) => {
      return doc_number ? doc_number : "";
    },
  },
  Cliente: {
    field: "service.company",
    callback: (company) => {
      return company ? company.name : "";
    },
  },
  "Facturar a": {
    field: "service.company",
    callback: (company) => {
      return company ? company.company_bill.name : "";
    },
  },
  "Depósito de retiro": {
    field: "deposit_pick",
    callback: (deposit_pick) => {
      return deposit_pick ? deposit_pick.name : "";
    },
  },
  "Depósito de entrega": {
    field: "deposit",
    callback: (deposit) => {
      return deposit ? deposit.name : "";
    },
  },
  "Fecha de operación": {
    field: "date",
    callback: (date) => {
      return moment(date).isValid()
        ? moment(date).format("DD/MM/YYYY HH:mm")
        : "";
    },
  },
  "Sobre estadía": {
    field: "container_expiration",
    callback: (container_expiration) => {
      return moment(container_expiration).isValid()
        ? moment(container_expiration).format("DD/MM/YYYY")
        : "";
    },
  },
  Contenedor: "container_number",
  "Tipo de contenedor": {
    field: "container_size",
    callback: (size) => {
      return size ? size.name : "";
    },
  },
  Placa: {
    field: "truck",
    callback: (truck) => {
      return truck ? truck.plate : "";
    },
  },
  Conductor: {
    field: "driver",
    callback: (driver) => {
      return `${driver ? `${driver.name} ${driver.last_name}` : ""}`;
    },
  },
  "Empresa de transporte": {
    field: "truck",
    callback: (truck) => {
      return truck && truck.provider ? truck.provider.name : "";
    },
  },
  Solicitante: {
    field: "service",
    callback: (service) => {
      return service.applicant
        ? `${service.applicant.name} ${service.applicant.last_name}`
        : "";
    },
  },
  "Creado el": {
    field: "created_at",
    callback: (value) => {
      return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
    },
  },
  Estado: "status.name",
};

export default devolutions_fields;
